import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronLargeTop"><Path fillRule="evenodd" clipRule="evenodd" d="M12.639 10.0018C12.2452 9.76765 11.755 9.76765 11.3613 10.0018L3.13342 14.894C2.77739 15.1057 2.31716 14.9887 2.10546 14.6326C1.89377 14.2766 2.01078 13.8164 2.36681 13.6047L10.5947 8.71245C11.4609 8.19741 12.5394 8.19741 13.4056 8.71245L21.6334 13.6047C21.9895 13.8164 22.1065 14.2766 21.8948 14.6326C21.6831 14.9887 21.2228 15.1057 20.8668 14.894L12.639 10.0018Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeTop;
